document.addEventListener('DOMContentLoaded', function() {
  let swiperMedia = new Swiper('.slider-media', {
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    slidesPerView: 'auto',
    speed: 1500,
    grabCursor: true,
    mousewheel: true,
    keyboardControl:true,
    centeredSlides: true,
    effect:'zoom',
    zoom: {
      maxRatio: 1.8,
      minRatio: 1,
    }
  })

});
